import React from 'react';
import Button from '@material-ui/core/Button';
import { ClipLoader } from 'react-spinners';
import styled from 'styled-components';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';

const icon = css`
  margin-right: 10px !important;
  border-top-color: white !important;
  border-right-color: white !important;
  border-bottom-color: transparent;
  border-left-color: white !important;
`;

const LoginButton = styled(Button)`
  margin-top: 40px !important;
  width: 100%;
  background-color: #FE4642 !important;
`;

const SpinnerLoginButton = (props) => {
  const {
    loading, text, onClick,
  } = props;
  return (
    <div style={{ width: '70%' }}>
      <LoginButton
        variant="contained"
        color="secondary"
        onClick={onClick}
      >
        {
          loading ? <ClipLoader css={icon} size={16} /> : ''
        }
        {text}
      </LoginButton>
    </div>
  );
};

SpinnerLoginButton.propTypes = {
  loading: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default SpinnerLoginButton;
